export default function (href) {
  let l = document.createElement('a')
  l.href = href
  return l
}
